import React, { useState, useEffect } from "react";
import { Divider, Flex, Layout, Menu } from "antd";
import styled from "styled-components";
import Logo from "../SVGs/Logo";
import DashBoardAdmin from "../DashBoardAdmin/DashBoardAdmin";
import NewRestaurantAdmin from "../NewRestaurantAdmin/NewRestaurantAdmin";
import NewCharacteristicsAdmin from "../NewCaracteristicsAdmin/NewCaracteristicsAdmin";
import "./MenuNavbarAdmin.css";
const { Sider, Content } = Layout;

const StyledMenuItem = styled(Menu.Item)`
  padding: 12px 20px;
`;

const StyledHorizontalMenu = styled(Menu)`
  display: flex;
  width: 100vw;
  max-width: 100vw;
  height: 10%;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: sticky;
  background-color: white;

  svg {
    fill: #333;
  }
`;

export default function MenuNavbarAdmin() {
  const [collapsed, setCollapsed] = useState(false);
  const [activePage, setActivePage] = useState("Inicio");
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mobileUserAgents = [
      "Android",
      "webOS",
      "iPhone",
      "iPad",
      "iPod",
      "BlackBerry",
      "Windows Phone",
    ];
    const userAgent = navigator.userAgent;
    const isMobileDevice = mobileUserAgents.some((mobileAgent) =>
      userAgent.includes(mobileAgent)
    );
    setIsMobile(isMobileDevice);
  }, []);

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const changePage = ({ key }) => {
    setActivePage(key);
  };

  const renderPageContent = () => {
    switch (activePage) {
      case "Inicio":
        return <DashBoardAdmin />;
      case "Novo Restaurante":
        return <NewRestaurantAdmin />;
      case "Novas Caracteristicas":
        return <NewCharacteristicsAdmin />;
      default:
        return null;
    }
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {!isMobile && (
        <Sider
          collapsible
          collapsed={collapsed}
          onCollapse={toggleCollapsed}
          theme="dark"
          style={{
            paddingTop: "10px",
          }}
        >
          <Flex align="center" justify="center">
            <Logo />
          </Flex>
          <Divider
            style={{
              color: "#333",
            }}
          />
          <Menu
            theme="dark"
            mode="inline"
            onClick={changePage}
            selectedKeys={[activePage]}
            style={{
              width: "100%",
              height: "90vh",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <StyledMenuItem key="Inicio">Início</StyledMenuItem>
            <StyledMenuItem key="Novo Restaurante">
              Novo Restaurante
            </StyledMenuItem>
            <StyledMenuItem key="Novas Caracteristicas">
              Novas Características
            </StyledMenuItem>
          </Menu>
        </Sider>
      )}
      {isMobile && (
        <StyledHorizontalMenu
          theme="dark"
          mode="horizontal"
          onClick={changePage}
          selectedKeys={[activePage]}
          expandIcon
        >
          <StyledMenuItem key="Inicio">Início</StyledMenuItem>
          <StyledMenuItem key="Novo Restaurante">
            Novo Restaurante
          </StyledMenuItem>
          <StyledMenuItem key="Novas Caracteristicas">
            Novas Características
          </StyledMenuItem>
        </StyledHorizontalMenu>
      )}
      <Layout className="site-layout">
        <Content style={{ margin: "0", overflowX: "hidden" }}>
          {renderPageContent()}
        </Content>
      </Layout>
    </Layout>
  );
}
